import { memo, type FunctionComponent } from 'react';
// Material UI imports
import type { AlertProps } from '@mui/material/Alert';
// local imports
import InlineAlert from './InlineAlert';

type FetchFailedAlertProps = {
  readonly flat?: boolean;
  readonly message?: string;
  readonly sx?: AlertProps['sx'];
};

const FetchFailedAlert: FunctionComponent<FetchFailedAlertProps> = ({
  flat = false,
  message = 'error.fetch_failed',
  sx
}) => (
  <InlineAlert severity="error" message={message} flat={flat} sx={sx}/>
);

export default memo(FetchFailedAlert);
